export default function translate(i18n, propriete) {
  let libellePropriete = propriete;
  if (libellePropriete.indexOf('objectifsVente') !== -1) {
    const prefixI18n = 'catalogue.validation.objectifsVente.';
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (libellePropriete === 'Annee') {
      return i18n.t(`${prefixI18n}anne`);
    }
    if (libellePropriete === 'MontantHt') {
      return i18n.t(`${prefixI18n}montantHt`);
    }
    if (libellePropriete === 'CommercialId') {
      return i18n.t(`${prefixI18n}commercial`);
    }
  }
  return propriete;
}
